module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns",
    staticStyle: {
      "min-height": "800px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-5 is-offset-1"
  }, [_c('div', {
    staticClass: "title is-2"
  }, [_vm._v("Bundle of Sticks")]), _vm._v(" "), _c('p', {
    staticClass: "title is-3 has-text-muted"
  }, [_vm._v("$ 15")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("This bundle of sticks provides an earthy fragrance and aesthetic natural appeal. Your bundle of sticks will come with a personalized note. The perfect natural gift for any time of year!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "level"
  }, [_c('router-link', {
    staticClass: "button is-large is-primary level-item has-text-centered",
    attrs: {
      "to": "/order"
    }
  }, [_vm._v("Buy Now")])], 1), _vm._v(" "), _c('br')])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "image is-2by2"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.scotch.io/2842/b7yhhuUPSGO1fEkMHD6P_sticks.jpeg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e175d8a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 169
// module chunks = 0